import Language from "../singleton/language";

export default {

    getAll: Language.getAll.bind(Language),

    set: Language.set.bind(Language),

    get: Language.get.bind(Language)

}